'use client';
import { Button } from '@/components/ui/button';
import { useRouter } from 'next/navigation';
// import { BarChart3, Brain, FileBarChart2, ArrowRight } from "lucide-react";
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { Navbar } from '@/components/layout/Navbar';
import { Footer } from '@/components/layout/Footer';
// import { PricingTables } from "@/components/PricingTables";
import { ChatTeaser } from '@/components/ChatTeaser';

export default function HomePage() {
  const router = useRouter();

  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const staggerChildren = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-950 to-slate-900">
      <Navbar />

      <main className="flex-1 flex flex-col items-center justify-center px-4 py-24 pt-32">
        <ChatTeaser />
      </main>

      {/* <div className="bg-gradient-to-b from-blue-900/20 via-blue-900/10 to-slate-900 py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h2
            className="text-3xl sm:text-4xl font-bold text-white mb-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Ready to Analyze Your Data?
          </motion.h2>
          <motion.p
            className="text-xl text-slate-300 mb-12"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Get started today and unlock the power of AI-driven data analysis.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <Button
              size="lg"
              className="bg-blue-600 hover:bg-blue-700 text-white"
              onClick={() => router.push("/chat")}
            >
              Start for Free
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </motion.div>
        </div>
      </div> */}

      <Footer />
    </div>
  );
}
